import React from "react";
import { BlogStatus } from "../../types/blogType";
import { ProductStateType, StatusType } from "../../types/index";

type StatusProps = {
	status: StatusType | ProductStateType | BlogStatus;
	fontSize: string;
	className?: string;
};

const Status = ({ status, fontSize, className }: StatusProps): JSX.Element => {
	const STATUS_COLOR =
		status === "no status"
			? "text-blind"
			: status === "pending" || status === "draft"
			? "text-warning"
			: status === "completed" ||
			  status === "approved" ||
			  status === "published"
			? "text-great"
			: status === "failed" || status === "deleted"
			? "text-danger"
			: "text-info";
	return (
		<div className={`${className} ${fontSize}`}>
			<i className={`fas fa-circle ${STATUS_COLOR} mr-2`}></i> {status}
		</div>
	);
};

Status.defaultProps = {
	status: "no status",
	fontSize: "text-xs",
	className: "",
};

export default Status;
